export const SET_USER = 'SET_USER'
export const SET_OPEN_BUNDLES = 'SET_OPEN_BUNDLES'
export const SET_PAPERS = 'SET_PAPERS'
export const SET_REPORTED = 'SET_REPORTED'
export const SET_DELIVERY = 'SET_DELIVERY'
export const UPDATE_DELIVERY = 'UPDATE_DELIVERY'
export const ADD_REPORTED = 'ADD_REPORTED'
export const LOCK_BOTTOM_NAV = 'LOCK_BOTTOM_NAV'
export const UNLOCK_BOTTOM_NAV = 'UNLOCK_BOTTOM_NAV'
export const SET_LAST_SELECTED_BUNDLE_ID = 'SET_LAST_SELECTED_BUNDLE_ID'
export const REMOVE_LAST_SELECTED_BUNDLE_ID = 'REMOVE_LAST_SELECTED_BUNDLE_ID'
export const SET_APP_MODE = 'SET_APP_MODE'
export const SET_ALERTS_SHOWN = 'SET_ALERTS_SHOWN'
export const RESET_CUSTOMER_STATE = 'RESET_CUSTOMER_STATE'
export const SET_IMPERSONATED_ID = 'SET_IMPERSONATED_ID'

